import { render, staticRenderFns } from "./DashboardDivisionOffier.vue?vue&type=template&id=6d48802e&scoped=true&"
import script from "./DashboardDivisionOffier.vue?vue&type=script&lang=js&"
export * from "./DashboardDivisionOffier.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDivisionOffier.vue?vue&type=style&index=0&id=6d48802e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d48802e",
  null
  
)

export default component.exports